export const REPORT_USER_LIST = [
  "dsteenerson@diservices.com",
  "bcoleman@diservices.com",
  "jmorrison@diservices.com",
  "amiklovic@diservices.com",
  "atalcott@diservices.com",
  "diservices.dms@gmail.com",
];
